export const isFeatureFlagActive = (name: string): boolean => {
  return window?.__AUTH_STATE__?.featureFlags?.includes(name);
};
